export default __webpack_public_path__ + "5fca8640d287153fa0f0bb6456109d53.svg";